import { Component, type ReactNode } from "react";

type HeroDLProps = {
  title: string;
  subtitle?: string;
  backgroundImage: string;
  backgroundPosition?: string;
  height?: number;
};

export class HeroDL extends Component<HeroDLProps> {
  render(): ReactNode {
    return (
      <div className="h-48 md:h-64 relative">
        <div className="w-full h-full hidden md:block">
          <div
            className={`bg-${this.props.backgroundImage} bg-cover ${this.props.backgroundPosition ? this.props.backgroundPosition : "bg-center md:bg-top"} min-h-[217px] h-full`}
          />
        </div>

        {/*<div className="md:flex container md:relative md:justify-center">*/}
        <div className="absolute top-0 left-0 flex justify-center items-center w-full h-full bg-black/[.25]">
          <div className="container text-black md:text-white">
            <div className="font-serif text-3xl text-left w-full">{this.props.title}</div>
            {this.props.subtitle && (
              <div className="font-serif text-xl text-left w-full">{this.props.subtitle}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
